export default "__VITE_ASSET__4XfePitH__"